import WebViewer from '../WebViewer';

export default class View {

    constructor() {
        this.app = null;
    }

    setApp(app) {
        this.app = app;
    }

    getApp() {
        return this.app;
    }

    createView(model) {

    }

    onRendered() {

    }

}